export const CARDS = 'cards';
export const ACCOUNTS = 'accounts';
export const CARD = 'card';
export const ACCOUNT = 'account';
export const MAIN_CA_SCREEN = 'main ca screen';
export const LINKED_ACCOUNT = 'linked account';
export const FRAUD_SOFT_BLOCK = 'soft_block';
export const FRAUD_HARD_BLOCK = 'hard_block';
export const IDENTITY = 'identity';
export const INCOME_ADDRESS = 'income_address';
export const TRANSFER = 'transfer';
export const BANNER = 'banner';
export const OLD = 'old';
export const NEW = 'new';
export const GLOBAL_ACCOUNT = 'Global Account';
export const ADD_NEW_CARD = 'Add New Card';
export const USE_LINKED_CARD = 'Use Linked Card';
export const DRAFT = 'draft';
export const REPEAT = 'repeat';
export const RECIPIENT = 'recipient';
export const RESUME = 'resume';
export const INDIVIDUAL = 'individual';
export const SUMSUB = 'sumsub';
export const PAYMENT = 'payment';
export const DELIVERY = 'delivery';
export const CLOSE_TO_LIMIT = 'close_to_limit';
export const CALCULATOR = 'calculator';
export const PAYMENT_CONFIRMATION = 'payment_confirmation';
export const DOB = 'DOB';
export const SELF = 'self';
export const BUSINESS = 'business';
export const COUNTRY_AND_METHOD = 'country_and_method';
export const DELIVERY_METHOD_LIST = 'delivery_method_list';
export const SENDING_METHOD = 'sending_method';
export const CUSTOM = 'custom';
export const METHOD_SUGGESTION = 'method_suggestion';
export const METHOD_INVITATION = 'invitation';
export const MAIN = 'main';
export const PROMO = 'promo';
export const CA_TOS = 'ca_tos';
export const CA_FACIAL_SCAN = 'ca_facial_scan';
export const US_TOS = 'us_tos';
export const US_ESING = 'us_esign';
export const ONBOARDING = 'onboarding';
export const MAIN_SCREEN = 'main_screen';
export const PROFILE = 'profile';
export const SDD = 'SDD';
export const HARDBLOCK = 'hardblock';
export const LOGIN_AMPLITUDE = 'login';
export const SIGNUP_AMPLITUDE = 'signup';
export const ERROR = 'error';
export const REGULAR = 'regular';
export const INVITE_FRIENDS = 'invite_friends';
export const GIFT = 'gift';
export const EARN_BONUS = 'earn_bonus';
export const GENERAL = 'general';
export const RECIPIENT_MAIN_INFO = 'recipient_main_info';
export const RECIPIENT_ADDITIONAL_INFO = 'recipient_additional_info';
export const SENDER_INFO = 'sender_info';
export const TRANSFER_ADDITIONAL_INFO = 'transfer_additional_info';
export const MAIN_SCREEN_TOP = 'main_screen_top';
export const PROFILE_SCREEN = 'profile_screen';
export const DELIVERY_OPTION_SCREEN = 'delivery_options_screen';
export const PAYMENT_OPTIONS_SCREEN = 'payment_options_screen';
export const GA = 'GA';

export const topUpMethods = {
    BANK_CARD: 'card',
    BANK_TRANSFER: 'bank transfer',
    APPLE_PAY: 'apple pay',
    GOOGLE_PAY: 'google pay',
    SALARY: 'salary',
} as const;

export type TopUpMethodKey = keyof typeof topUpMethods;
export type TopUpMethodValue = (typeof topUpMethods)[TopUpMethodKey];

export const requestPaymentMethods = {
    CARD: 'card',
    NEW_CARD: 'new_card',
    ACCOUNT: 'account',
    GLOBAL_ACCOUNT: 'global_account',
    NEW_ACCOUNT: 'new_account',
} as const;

export type RequestPaymentMethodKey = keyof typeof requestPaymentMethods;
export type RequestPaymentMethodValue = (typeof requestPaymentMethods)[RequestPaymentMethodKey];

export const cardType = {
    PLASTIC: 'plastic',
    VIRTUAL: 'virtual',
} as const;

export type CardTypeKey = keyof typeof cardType;
export type CardTypeValue = (typeof cardType)[CardTypeKey];

export const AMPLITUDE_PARAM_VALUES = {
    CARDS,
    ACCOUNTS,
    CARD,
    ACCOUNT,
    MAIN_CA_SCREEN,
    LINKED_ACCOUNT,
    FRAUD_SOFT_BLOCK,
    FRAUD_HARD_BLOCK,
    IDENTITY,
    INCOME_ADDRESS,
    TRANSFER,
    BANNER,
    OLD,
    NEW,
    GLOBAL_ACCOUNT,
    ADD_NEW_CARD,
    USE_LINKED_CARD,
    DRAFT,
    REPEAT,
    RECIPIENT,
    RESUME,
    INDIVIDUAL,
    SUMSUB,
    PAYMENT,
    DELIVERY,
    CLOSE_TO_LIMIT,
    CALCULATOR,
    PAYMENT_CONFIRMATION,
    DOB,
    SELF,
    BUSINESS,
    COUNTRY_AND_METHOD,
    DELIVERY_METHOD_LIST,
    SENDING_METHOD,
    CUSTOM,
    METHOD_SUGGESTION,
    METHOD_INVITATION,
    CA_TOS,
    CA_FACIAL_SCAN,
    US_TOS,
    US_ESING,
    ONBOARDING,
    MAIN_SCREEN,
    PROFILE,
    SDD,
    HARDBLOCK,
    LOGIN_AMPLITUDE,
    SIGNUP_AMPLITUDE,
    ERROR,
    REGULAR,
    INVITE_FRIENDS,
    GIFT,
    EARN_BONUS,
    GENERAL,
    RECIPIENT_MAIN_INFO,
    RECIPIENT_ADDITIONAL_INFO,
    SENDER_INFO,
    TRANSFER_ADDITIONAL_INFO,
    MAIN_SCREEN_TOP,
    PROFILE_SCREEN,
    DELIVERY_OPTION_SCREEN,
    PAYMENT_OPTIONS_SCREEN,
    topUpMethods,
    requestPaymentMethods,
    cardType,
    GA,
} as const;

export type AmplitudeParamValueKey = keyof typeof AMPLITUDE_PARAM_VALUES;
export type AmplitudeParamValue = (typeof AMPLITUDE_PARAM_VALUES)[AmplitudeParamValueKey];
